export default __webpack_public_path__ + "91522ec.png";